import { EventsService } from './../../../services/events.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MediaLibraryHttpService } from 'src/app/http/media-library-http.service';

@Component({
    selector: 'app-new-folder-modal',
    templateUrl: './new-folder-modal.component.html',
    styles: [],
})
export class NewFolderModalComponent implements OnInit {
    constructor(
        public activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private mediaLibraryHttpService: MediaLibraryHttpService,
        private eventsServices: EventsService
    ) {}

    newFolderForm = this.fb.group(
        {
            folderName: [null, Validators.required],
        },
        { updateOn: 'submit' }
    );

    formBusy: boolean;

    alert: any;

    ngOnInit(): void {}

    onSubmit() {
        this.newFolderForm.markAsTouched();

        if (this.newFolderForm.valid) {
            this.formBusy = true;

            this.mediaLibraryHttpService.newFolder(this.newFolderForm.value).subscribe(
                (result) => {
                    this.eventsServices.trigger.next({ name: 'refreshFolders', value: null });
                    this.activeModal.close();
                },
                (error) => {
                    this.formBusy = false;
                    this.newFolderForm.setErrors({ exists: true });
                }
            );
        }
    }
}
